<!-- 抽奖奖品核销页 -->
<template>
<div class='myPrize-page'>
  <div class="myPrize-container">
    <div class="prize-list" v-if="listData.length>0&&!isLoading">
      <div class="item df-between" v-for="(item,index) in listData" :key="index">
        <div class="item-left">
          <img :src="downloadPath + item.iconUrl" alt="">
          <div class="prize-info">
            <div class="name">{{ item.prizeName }}</div>
            <div class="time">{{ item.winningTimeStr }}</div>
          </div>

        </div>
        <div class="item-right df-center" @click="handlePrizeUse(item,index)" :class="{'yet-use':item.writeOffState==2}"> {{ item.writeOffState==2 ? '已' : '' }}核销</div>
      </div>
    </div>
    <div class="empty" v-if="listData.length==0&&!isLoading">没有更多数据了！</div>
  </div>
  <v-dalog v-on:handleBtnLeft='handleBtnLeft' v-on:handleBtnRight='handleBtnRight' :isCenter='true' :isShowDalog='isShowDalog' :dalogBtn1='dalogBtn1' :dalogBtn2='dalogBtn2' :pTagMarginBottom='"30px"' :dalogContent='dalogContent'></v-dalog>
</div>
</template>

<script>
import vDalog from '@/components/dalog/v-dalog'
import { Toast } from 'vant'
import { mapState } from 'vuex'
export default {
data() {
return {
  isLoading:false,
  prizeIdenx: 0,
  isShowDalog:false,
  dalogBtn1: '否',
  dalogBtn2: '是',
  dalogContent: '是否核销产品，核销后不可再次领取',
  listData: []
};
},
components: {
  vDalog
},
computed: {
  ...mapState({
    downloadPath: state => state.downloadPath
  })
},
created() {
  this.initData()
  setTimeout(() => {
    this.initShare('感控工作间的使用经验分享','可以参考借鉴哦')
  }, 500);
},
methods: {
  initData () {
    this.isLoading = true
    let params = {
      data: {
        mobile: this.$route.query.mobilePhone
      }
    };
    this.$http.queryUserActivityRecordByMobile(params).then((res) => {
      this.isLoading = false
      if (res.code == 0) {
        if (res.data.prizeId) {
          this.listData.push(res.data)
        }
      } else {
        Toast(res.msg)
      }
    });
  },
  handlePrizeUse (item,index) {
    this.prizeIdenx = index
    if (item.writeOffState == 2) { // 已核销
      return
    }
    this.isShowDalog = true
  },
  handleBtnLeft () {
    this.isShowDalog = false
  },
  handleBtnRight () {
    let params = {
      data: {
        mobile: this.$route.query.mobilePhone,
        operType: "4" // 1-获取抽奖机会，2-使用抽奖机会，3-抽中奖品，4-核销奖品
      }
    };
    this.$http.editUserActivityRecord(params).then((res) => {
      Toast(res.msg)
      this.isShowDalog = false
      this.listData[this.prizeIdenx].writeOffState = 2
    });
  }

},
}
</script>
<style lang='scss' scoped>
.myPrize-page{
  height: 100vh;
  background: #f5f7f8;
  .myPrize-container{
    font-family: PingFang SC Regular, PingFang SC Regular-Regular;
    .prize-list{
      padding: 15px 12px;
      .item{
        margin-bottom: 10px;
        padding: 8px 10px 8px 12px;
        background-color: #fff;
        border-radius: 10px;
        .item-left{
          display: flex;
          align-items: center;
          img{
            width: 54px;
            height: 85px;
          }
          .prize-info{
            margin-left: 12px;
            display: flex;
            flex-direction: column;
            text-align: left;
            .name{
              margin-bottom: 20px;
              font-size: 16px;
              color: #333333;
            }
            .time{
              font-size: 12px;
              color: #999999;
            }
          }

        }
        .item-right{
          width: 90px;
          height: 36px;
          background: linear-gradient(#fff35a 0%, #ffba0c 100%) #ffffff;
          border-radius: 18px;
          font-size: 18px;
          color: #ab441c;
        }
        .yet-use{
          background: linear-gradient(#e3e3e3 0%, #bbbbbb 99%) #ffffff;
          color: #747474;
        }
      }
    }
    .empty{
      height: 100vh;
      padding-top: 20px;
      background-color: #fff;
      font-size: 16px;
    }


  }
}
</style>